import React from "react";
import { motion } from "framer-motion";
import { Card, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getSelectedTerm } from "store/slices/termSlice";
import IconLoader from "components/IconLoader/IconLoader";

const QuickStatsCards = () => {
  const currentTerm = useSelector(getSelectedTerm);

  return (
    <Row className="mb-4">
      <Col md={12}>
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1 }}
        >
          <Card className="shadow-sm h-100">
            <Card.Body className="d-flex align-items-center">
              <div className="bg-primary bg-opacity-10 p-3 rounded mx-3">
                <IconLoader icon="mdiSchoolOutline" className="text-primary" size={1} />
              </div>
              <div>
                <h6 className="mb-0">Aktif Dönem</h6>
                <p className="mb-0 text-primary fw-bold">{currentTerm?.name || "Belirlenmedi"}</p>
              </div>
            </Card.Body>
          </Card>
        </motion.div>
      </Col>
    </Row>
  );
};

export default QuickStatsCards;
